import { useMutation, useQueryClient } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import { queryKeys } from "../../lib/query-keys";

interface MoveNodeParams {
  id: string;
  new_parent_id: string;
}

export function useMoveNode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: MoveNodeParams) =>
      mcpClient.moveNode(params),
    onSuccess: (_node, vars) => {
      qc.invalidateQueries({ queryKey: queryKeys.libraryTree() });
      qc.invalidateQueries({ queryKey: queryKeys.libraryNode(vars.id) });
      qc.invalidateQueries({ queryKey: queryKeys.workspace() });
    },
  });
}
